import { AxiosError, AxiosResponse } from "axios";
import { DataType, FieldType } from "@websential/cosmic-v20";
import { IGetListRequest, IResponse, IServerError } from "../models/common";
import {
	IWSIBMaximumEarnings,
	IWSIBMaximumEarningsListPayload,
	IWSIBMaximumEarningsResponse,
} from "../models/WSIBMaximumEarnings";

import { GridSize } from "@mui/material";
import http from "../common/http-commons";

export const WSIBMaximumEarningsService = {
	getWSIBMaximumEarnings: async (
		// clientId: string,
		runGetListAPICall: boolean,
		provinceId: string,
		effectiveDate: String | null,
		endDate: string | null,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<
		| IWSIBMaximumEarningsListPayload
		| IServerError
		| IResponse
		| IWSIBMaximumEarningsResponse[]
		| null
	> => {
		if (!runGetListAPICall) return null;

		try {
			const response: AxiosResponse<IWSIBMaximumEarningsListPayload> =
				await http.get<IWSIBMaximumEarningsListPayload>(
					"/v1/wsib-max-earnings-setup/",
					{
						params: {
							province_id: provinceId,
							effective_date: effectiveDate,
							end_date: endDate,
							search_query: data.search_query,
							order_by: data.order_by,
							order_direction: data.order_direction,
							page: data.page,
							size: data.size,
						},
					},
				);
			// await http.get<IWSIBMaximumEarningsListPayload>(
			// 	"/v1/wsib-max-earnings-setup/?short_name=" +
			// 		shortName +
			// 		"&label=" +
			// 		label +
			// 		"&description=" +
			// 		description +
			// 		"&province_id=" +
			// 		provinceId +
			// 		"&parent_id=" +
			// 		parentId +
			// 		"&effective_date=" +
			// 		effectiveDate +
			// 		"&end_date=" +
			// 		endDate +
			// 		"&search_query=" +
			// 		data.search_query +
			// 		"&order_by=" +
			// 		data.order_by +
			// 		"&order_direction=" +
			// 		data.order_direction +
			// 		"&page=" +
			// 		data.page +
			// 		"&size=" +
			// 		data.size

			// );

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getById: async (
		clientId: string,
		id: string | undefined,
		navigateToLogout: (path: string) => void,
	): Promise<IWSIBMaximumEarnings | IServerError | IResponse | null | any> => {
		if (!id) return null;
		try {
			const response: AxiosResponse<IWSIBMaximumEarnings> =
				await http.get<IWSIBMaximumEarnings>(
					`/v1/wsib-max-earnings-setup/${id}/`,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	create: async (
		requestPayload: any,
	): Promise<IWSIBMaximumEarnings | IServerError | IResponse | any> => {
		if (requestPayload.id) {
			try {
				const response: AxiosResponse<IWSIBMaximumEarnings> =
					await http.put<IWSIBMaximumEarnings>(
						`/v1/wsib-max-earnings-setup/${requestPayload.id}/`,
						requestPayload,
					);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		try {
			const response: AxiosResponse<IWSIBMaximumEarnings> =
				await http.post<IWSIBMaximumEarnings>(
					`/v1/wsib-max-earnings-setup/add-wsib-max-earnings`,
					requestPayload,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delWSIBMaximumEarnings: async (
		delPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/wsib-max-earnings-setup/${delPayload.wsibMaximumEarningsId}/`,
			);

			if (response.status === 204) {
				return "Maximum Earnings has been deleted successfully";
			} else if (response.status === 200) {
				return "Maximum Earnings has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delBulkWSIBMaximumEarningses: async (
		requestPayload: any,
	): Promise<string | IServerError | IResponse> => {
		try {
			const response = await http.delete<string>(`/v1/wsibMaximumEarnings/`, {
				data: requestPayload.wsibMaximumEarningsIds,
			});
			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getGetWSIBMaximumEarningsDDL: async () // clientId: string
	: Promise<any | IServerError | IResponse | null> => {
		const response: AxiosResponse<any[]> = await http.get<any[]>(
			`/v1/wsib-max-earnings-setup/ddl`,
		);

		if (response.status === 200) {
			return response.data;
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	getParentDDL: async (): Promise<any | IServerError | IResponse | null> => {
		try {
			const response: AxiosResponse<any[]> =
				await http.get<any[]>(`/v1/parent`);

			if (response.status === 200) {
				return response.data;
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			return {
				status: false,
				message: errorMessage,
			};
		}
	},
	archiveWSIBMaximumEarnings: async (
		archivePayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.post<string>(
				`/v1/wsibMaximumEarnings/${archivePayload.wsibMaximumEarningsId}/`,
			);

			if (response.status === 201) {
				return "WSIBMaximumEarnings has been archived successfully";
			} else if (response.status === 200) {
				return "WSIBMaximumEarnings has been archived successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				archivePayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
};
